<div>
	<a name="contacts"></a>
	<section class="bottom-boxes">
		<div class="items">
			<div class="item">
				<div class="img-wrp">
					<img
						width="199"
						height="214"
						alt=""
						src="assets/img/mobile-bottom.png"
						title=""
					/>
				</div>
				<div class="txt">
					<h3>
						{{ "footer-app-and-contacts.p1" | translate }}<br />
						<span class="small">{{ "footer-app-and-contacts.p2" | translate }}</span>
					</h3>
					@if (localizedCountry === "DE") {
						<div class="img-wrp">
							<a
								href="https://apps.apple.com/de/app/leasys-clickar/id848186972"
								target="_blank"
							>
								<img
									alt="App Store"
									src="assets/img/apple-store.png"
									title=""
								/>
							</a>
						</div>
						<div class="img-wrp">
							<a
								href="https://play.google.com/store/apps/details?id=com.fiat.clickar&hl=de"
								target="_blank"
							>
								<img
									alt="Google Play"
									src="assets/img/google-play.png"
									title=""
								/>
							</a>
						</div>
					} @else {
						<p>
							{{ "footer-app-and-contacts.p3" | translate }}<br />{{ "footer-app-and-contacts.p4" | translate }}
							<br />
							<strong>{{ "footer-app-and-contacts.p5" | translate }}</strong>
						</p>
						<a
							target="_blank"
							title=""
							[href]="'footer-app-and-contacts.url' | translate"
							class="btn btn-red no-margin"
						>
							{{ "footer-app-and-contacts.p6" | translate }}
						</a>
					}
				</div>
			</div>
			<div
				class="item customer-center"
				style="border-right: none !important"
			>
				<h3>{{ "footer-app-and-contacts.p7" | translate }}</h3>
				<ul>
					<li>
						<a
							[href]="'mailto:' + ('footer-app-and-contacts.email' | translate)"
							title=""
							target=""
							><img
								alt=""
								src="assets/img/mail.png"
								title=""
							/>
							<span>{{ "footer-app-and-contacts.p8" | translate }}</span>
						</a>
					</li>
					<li>
						<a [href]="'tel:' + ('footer-app-and-contacts.tel' | translate)"
							><img
								alt=""
								src="assets/img/tel.png"
								title=""
							/>
							<span>{{ "footer-app-and-contacts.tel" | translate }}</span>
						</a>
					</li>
				</ul>
			</div>
		</div>
	</section>
</div>
